// actions
import * as actions from './actions';

const initialState = {
  discount: null,
  errorCoupon: null,
  error: null,
  initial: false,
  loading: false,
};

export default function couponsReducer(state = initialState, action) {
  switch (action.type) {
    // VALIDATE COUPON
    case actions.VALIDATE_COUPON.REQUEST:
      return { ...state, loading: true };

    case actions.VALIDATE_COUPON.SUCCESS:
      return { ...state, initial: true, discount: action.payload.discount, errorCoupon: action.payload.error, loading: false, error: null };

    case actions.VALIDATE_COUPON.FAILURE:
      return { ...state, initial: false, loading: false, error: action.payload.error };

    case actions.CLEAR_COUPON_DISCOUNT:
      return { ...state, discount: null, errorCoupon: null };

    default:
      return state;
  }
};